import {
  List,
  Table,
  useTable,
  Modal,
  Show,
  ShowButton,
  Typography,
  Col,
  Row,
  FileField,
  Button,
  DateField,
  RefreshButton,
} from "@pankod/refine-antd";
import { useApiUrl, useTranslate, useShow } from "@pankod/refine-core";
import { Statuses } from "components/common";
import { IProject } from "interfaces/project";
import { IProviderContract } from "interfaces/providercontract";
import { useState } from "react";

const { Title, Text } = Typography;

export const ProjectProviderContractsTable: React.FC<{ record: IProject }> = ({
  record: project,
}) => {
  const API_URL = useApiUrl();
  const t = useTranslate();
  const [visible, setVisible] = useState(false);

  const { tableProps: provider_contractsableProps } =
    useTable<IProviderContract>({
      resource: "provider_contracts",
      permanentFilter: [
        {
          field: "project.id",
          operator: "eq",
          value: project.id,
        },
      ],
      syncWithLocation: false,
    });

  const { queryResult, showId, setShowId } = useShow<IProviderContract>({
    resource: "provider_contracts",
  });
  const { data, isLoading } = queryResult;
  const record = data?.data;
  return (
    <>
      <List title={t("provider_contracts.provider_contracts")}>
        <Table {...provider_contractsableProps} rowKey="id">
          <Table.Column
            key="description"
            dataIndex="description"
            title={t("provider_contracts.fields.name")}
          />

          <Table.Column<IProviderContract>
            dataIndex="status"
            title={t("price_offers.fields.status")}
            render={(value) => {
              return <Statuses status={value} />;
            }}
          />
          <Table.Column<IProviderContract>
            title={t("table.actions")}
            dataIndex="actions"
            render={(_, record) => (
              <ShowButton
                size="small"
                recordItemId={record.id}
                onClick={() => {
                  setShowId(record.id);
                  setVisible(true);
                }}
              />
            )}
          />
        </Table>
      </List>
      <Modal visible={visible} closable={false} footer={false} width={800}>
        <Show
          isLoading={isLoading}
          pageHeaderProps={{
            onBack: () => setVisible(false),
            extra: <RefreshButton hidden/>
          }}
          resource="provider_contracts"
          recordItemId={showId}
        >
          <Row gutter={20}>
            <Col xs={24} lg={30}>
              <Row gutter={10}>
                <Col xs={24} lg={12}>
                  <Title level={5}>{t("provider_contracts.fields.name")}</Title>
                  <Text>{record?.description}</Text>

                  <Title level={5}>
                    {t("provider_contracts.fields.status")}
                  </Title>
                  <Text>{t(`statusTypes.${record?.status}`)}</Text>

                  <Title level={5}>{t("provider_contracts.fields.date")}</Title>
                  <DateField value={record?.date} format="LL" />
                </Col>
                <Col xs={24} lg={12}>
                  <Title level={5}>
                    {t("provider_contracts.fields.requestDate")}
                  </Title>
                  <DateField value={record?.requestDate} format="LL" />

                  <Title level={5}>{t("provider_contracts.fields.file")}</Title>
                  <Row gutter={10}>
                  {record?.images?.map((data: any) => {
                    return (
                      <Col xs={24} lg={12}>
                        <FileField
                          target="_blank"
                          title={data?.name}
                          src={data?.url}
                        />
                      </Col>
                    );
                  })}
                  {/*<FileField src={record.image[0].url} />*/}
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Show>
      </Modal>
    </>
  );
};
